/*
 *
 * Do not edit directly
 * Generated on Thu, 24 Apr 2025 18:51:19 GMT
 *
 */

import PaletteIconStatusInfo from '@telus-uds/palette-allium/build/rn/icons/StatusInfo'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusWarning from '@telus-uds/palette-allium/build/rn/icons/StatusWarning'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
const theme = {
  appearances: {
    inverse: {
      description: 'Inverts the status colors',
      type: 'variant',
      values: [ true ]
    },
    priority: { type: 'variant', values: [ 'default', 'low', 'high' ] },
    purpose: {
      type: 'variant',
      values: [
        'default', 'brand',
        'subtle',  'success',
        'warning', 'error',
        'offer'
      ]
    }
  },
  rules: [
    { if: { purpose: 'brand' }, tokens: { iconColor: '#4b286d' } },
    { if: { purpose: 'subtle' }, tokens: { iconColor: '#676e73' } },
    {
      if: { purpose: 'success' },
      tokens: { icon: PaletteIconStatusSuccess, iconColor: '#2b8000' }
    },
    {
      if: { purpose: 'warning' },
      tokens: { icon: PaletteIconStatusWarning, iconColor: '#b4872c' }
    },
    {
      if: { purpose: 'error' },
      tokens: { icon: PaletteIconStatusError, iconColor: '#c12335' }
    },
    { if: { purpose: 'offer' }, tokens: { iconColor: '#7c53a5' } },
    {
      if: { priority: 'low' },
      tokens: {
        borderRadius: 99,
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4
      }
    },
    {
      if: { priority: 'high' },
      tokens: {
        backgroundColor: '#414547',
        borderRadius: 99,
        iconColor: '#ffffff',
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4,
        textColor: '#ffffff'
      }
    },
    {
      if: { priority: 'low', purpose: 'default' },
      tokens: { backgroundColor: '#f4f4f7' }
    },
    {
      if: { priority: 'high', purpose: 'default' },
      tokens: { backgroundColor: '#414547' }
    },
    {
      if: { priority: 'low', purpose: 'brand' },
      tokens: { backgroundColor: '#efedff' }
    },
    {
      if: { priority: 'high', purpose: 'brand' },
      tokens: { backgroundColor: '#4b286d' }
    },
    {
      if: { priority: 'low', purpose: 'subtle' },
      tokens: { backgroundColor: '#fafafa' }
    },
    {
      if: { priority: 'high', purpose: 'subtle' },
      tokens: { backgroundColor: '#676e73' }
    },
    {
      if: { priority: 'low', purpose: 'success' },
      tokens: { backgroundColor: '#f4f9f2' }
    },
    {
      if: { priority: 'high', purpose: 'success' },
      tokens: { backgroundColor: '#2b8000' }
    },
    {
      if: { priority: 'low', purpose: 'warning' },
      tokens: { backgroundColor: '#fff9ee' }
    },
    {
      if: { priority: 'high', purpose: 'warning' },
      tokens: { backgroundColor: '#b4872c' }
    },
    {
      if: { priority: 'low', purpose: 'error' },
      tokens: { backgroundColor: '#fff6f8' }
    },
    {
      if: { priority: 'high', purpose: 'error' },
      tokens: { backgroundColor: '#c12335' }
    },
    {
      if: { priority: 'low', purpose: 'offer' },
      tokens: { backgroundColor: '#f4f4f7' }
    },
    {
      if: { priority: 'high', purpose: 'offer' },
      tokens: {
        backgroundGradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: '#ffffff',
        textColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, priority: 'low' },
      tokens: { backgroundColor: '#2c2e30' }
    },
    {
      if: { inverse: true, priority: 'high' },
      tokens: {
        backgroundColor: '#ffffff',
        iconColor: '#2c2e30',
        textColor: '#2c2e30'
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    backgroundGradient: null,
    borderColor: null,
    borderRadius: null,
    borderWidth: null,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '700',
    icon: PaletteIconStatusInfo,
    iconColor: '#414547',
    iconGradient: null,
    iconPaddingTop: 0,
    iconSize: 20,
    marginLeft: 8,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    textColor: '#676e73',
    textLineHeight: 1.14285714286
  }
}
export default theme
